export const descriptionAttributes = [
  'variant_description',
  'variant_proddesc_online_body_text',
  'proddesc_online_body_text',
  'description'
]
export const BRICK_ATTRIBUTE = 'core_gs1_brick'
export const eanAttributes = ['ean', 'core_gtin', 'additional_eans']
export const excludedAttributes = ['name', 'core_sales_unit_content']
const unitSuffix = '_uom'
const unitFhSuffix = '_fhunit'
export const unitsRegex = new RegExp([unitSuffix, unitFhSuffix].join('|'))

export const EXCLUDED_ATTRIBUTES = [
  ...excludedAttributes,
  ...descriptionAttributes,
  ...eanAttributes,
  BRICK_ATTRIBUTE
].reduce((acc, it) => ({ ...acc, [it]: 1 }), {})
